/* eslint-disable */

import Vue from 'vue';
import Router from 'vue-router';

import Layout from '@/components/Layout/Layout';
import Login from '@/pages/Login/Login';
import ErrorPage from '@/pages/Error/Error';
import Dashboard from '@/pages/Dashboard/Dashboard';

import Excursiones from '@/pages/Excursiones/Excursiones'
import Pickups from '@/pages/Pickups/Pickups'
import Returns from '@/pages/Returns/Returns'
import Incomplete from '@/pages/Incomplete/Incomplete'
import PlanDay from '@/pages/PlanDay/PlanDay'
import SendPlanning from '@/pages/Send/SendPlanning'
import Check from '@/pages/Check/Check'

// Admin panel
import Admin from '@/pages/Admin/Admin'
// Analytics panel
import Analytics from '@/pages/Analytics/Analytics'

// Auth
import Actions from './store/modules/auth';

import store from './store';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/error',
      name: 'Error',
      component: ErrorPage,
    },
    {
      path: '/app',
      name: 'Layout',
      beforeEnter: (to, from, next, actions = Actions) => {
        store.commit('ISLOADING', ["general", true]);
        actions.actions.verifyToken((isCorrect) => {
          isCorrect ? next() : next('/login');
        });
        setTimeout(() => {
          store.commit('ISLOADING', ["general", false])
        }, 2000);
      },
      component: Layout,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'excursiones/excursiones',
          name: 'Buses Excursiones',
          component: Excursiones,
          beforeEnter: (to, from, next) => {
            store.dispatch("layout/setActiveTabAndOption", {tab: 'Excursions', option: 'Activity'})
            //store.dispatch("layout/loadData", {reset: false},{ root: true})
            next()
          } 
        },
        {
          path: 'excursiones/pickups',
          name: 'Buses Recogida',
          component: Pickups,
        },
        {
          path: 'excursiones/returns',
          name: 'Buses Dejadas',
          component: Returns,
        },
        {
          path: 'excursiones/reservas-sin-parada',
          name: 'Reservas sin parada asignada',
          component: Incomplete,
        },
        {
          path: 'excursiones/reservas-sin-grupo',
          name: 'Reservas sin grupo asignado',
          component: Incomplete,
        },
        {
          path: 'excursiones/planificacion-dia',
          name: 'Resumen planificación del día',
          component: PlanDay,
        },
        {
          path: 'excursiones/envio-planificacion',
          name: 'Configuración del envío de planificación de buses',
          component: SendPlanning,
        },
        {
          path: 'excursiones/check',
          name: 'Checkeo de reservas',
          component: Check,
        },
        {
          path: 'admin-panel',
          name: 'Administración',
          component: Admin,
        },
        {
          path: 'analytics-panel',
          name: 'Analítica',
          component: Analytics,
        },

      ],
    },
  ],
});